import type { LuggageTypes } from '@lt/api/dist/methods/packages/types';
import type { TransformedBackFlight } from '../../types/flights';
/*
    Мокаем данные багажа для рейса без конкретизации
*/
export const UNKNOWN_LUGGAGE: LuggageTypes = {
  comment: '',
  hand: {
    count: 1,
    weight: undefined,
  },
  hold: {
    count: 1,
    weight: undefined,
  },
};
/*
    Мокаем данные типа рейса без конкретизации
*/
export const NO_CONCRETIZATION_FLIGHT_TYPE: {
  type: TransformedBackFlight['type'];
  warning?: TransformedBackFlight['warning'];
  business: TransformedBackFlight['business'];
} = {
  type: 'charter',
  warning: false,
  business: false,
};
